import parseUrl from 'url-parse';

import { APP_CONFIG } from 'core';

import type { LinkProps } from '../@types';

/**
 * Checks if provided url is external.
 *
 */
export function isExternalUrl(to: LinkProps['to']) {
  const { hostname: urlHostname } =
    typeof to === 'string' ? parseUrl(to) : parseUrl(to?.pathname || '');
  const { hostname: appHostname } = parseUrl(APP_CONFIG.url);

  return urlHostname !== appHostname;
}
